import { createContext } from "preact";
import { login } from "./api-client";
import { useContext } from "preact/hooks";
import { Dispatch, SetStateAction } from "preact/compat";
import { UserAuthReq } from "@doors/api-client";

export interface UserCreds {
  jwt: string;
}

export interface AuthContext {
  user: UserCreds | null;
  setUser: Dispatch<SetStateAction<UserCreds | null>>;
}

export const AuthContext = createContext<AuthContext | null>(null);
const KEY = "admin-jwt";

export function useAuthContext() {
  return useContext(AuthContext)!;
}

function retrieveToken() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    // no-op
  }
}

function saveToken(jwt: string) {
  try {
    return localStorage.setItem(KEY, jwt);
  } catch {
    // no-op
  }
}

export function onLogout() {
  try {
    localStorage.removeItem(KEY);
    location.reload();
  } catch {
    // no-op
  }
}

export async function loadUser(tokenArg?: string): Promise<UserCreds | null> {
  const tok = tokenArg ?? retrieveToken();
  if (tok != null) {
    return { jwt: tok };
  }
  return null;
}

export async function attemptLogin(
  req: UserAuthReq,
  onSuccess: (u: UserCreds) => void
) {
  const { success, jwt } = await login(req);
  if (success && jwt) {
    saveToken(jwt);
    if (onSuccess != null) {
      const user = await loadUser(jwt);
      if (user != null) {
        onSuccess(user);
      }
    }
  }
  return success;
}
